import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { usePlayerAuth } from "../context/PlayerAuthContext";
import { toast } from "sonner";
import { ACADEMY_LOGO } from "../data/assets";

// Login-only dialog. New buyers set their password via the secure emailed /claim link.
export default function AuthDialog({ open, onClose, onSuccess }) {
  const { login } = usePlayerAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const player = await login(email.trim(), password);
      toast.success("Welcome back!");
      onClose();
      onSuccess && onSuccess(player);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid email or password.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md bg-[#111] border border-white/10 text-white" data-testid="auth-dialog">
        <DialogHeader>
          <img src={ACADEMY_LOGO} alt="" className="w-32 h-auto object-contain mb-2" />
          <DialogTitle className="font-headings text-2xl uppercase tracking-wide">Log In</DialogTitle>
          <DialogDescription className="text-white/50 text-sm">Access your training and Player Hub.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <input data-testid="auth-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email"
            className="w-full bg-[#0d0d0d] border border-white/10 rounded-md p-3 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#C41E24]" />
          <input data-testid="auth-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password"
            className="w-full bg-[#0d0d0d] border border-white/10 rounded-md p-3 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#C41E24]" />
          <button data-testid="auth-submit" type="submit" disabled={busy}
            className="w-full bg-[#C41E24] hover:bg-[#A0161D] text-white font-subheadings font-bold uppercase tracking-wider py-3 rounded-sm transition-colors disabled:opacity-60">
            {busy ? "Please wait…" : "Log In"}
          </button>
        </form>
        <p className="text-xs text-white/45 mt-2">First time? After purchase, use the secure <b className="text-white/70">Set Up My Profile</b> link in your welcome email.</p>
      </DialogContent>
    </Dialog>
  );
}
